// src/components/portal/ExternalLinkIcon.js — the small "visit website" icon
// used wherever a GP firm's website link appears (PortalMandates tiles,
// PortalMandateDetail's overview card) so it's drawn identically everywhere
// instead of copy-pasted per page.
export default function ExternalLinkIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  )
}
